module.exports = require('./helpers/bundle-url').getBundleURL('7XqoH') + "dark-mode.fd95cecc.svg";